

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface RoomParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Room {
    id?: number;
     roomNo:string; 
     isActive:string;
     floorId:any;
     buildingId:any;
    tenantId: any;
    branchId: any;
  
    floor?:any;
    building?:any;
  parameters?: RoomParameter[];
  links?: any;
}

export abstract class RoomData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Room[]>;
  abstract create(url: string, data: Room): Observable<Room[]>;
  abstract update(url: string, data: Room): Observable<Room>;
  abstract delete(url: string): Observable<any>;
 
}
